import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import { MultiRangeSlider } from "./MultiRangeSlider";

export const AdditionalFilter = ({
  experience,
  setExperience,
  qualifaction,
  setQualifaction,
  providerType,
  setProviderType,
  searchFilter,
  setSearchFilter,
  handleSearch,
  providerGrade,
  setProviderGrade,
  certificate,
  setCertificate,
  setAdditionFilter,
  minNps,
  setMinNps,
  maxNps,
  setMaxNps,
}) => {
  const ref = useRef();
  const getAdditionalFilter = useSelector(
    (state) => state?.NetworkIntelligenceReducer?.getAdditionalFilter
  );
  const certificateArray = ["NABL", "NABH", "CAP", "ISO"];
  const changeHandler = (name, value) => {
    setSearchFilter({ ...searchFilter, [name]: value });
  };
  const applyFilter = () => {
    handleSearch();
    ref.current.click();
  };
  return (
    <>
      <div class="offcanvas-header">
        <h3 id="offcanvasRightLabel">Filters</h3>
        <button
          type="button"
          ref={ref}
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setAdditionFilter(false)}
        ></button>
      </div>
      <div class="offcanvas-body">
        <div className="row">
        <div class="col-12">
            <h5>NPS</h5>
            <MultiRangeSlider
              minNps={minNps}
              maxNps={maxNps}
              setMinNps={setMinNps}
              setMaxNps={setMaxNps}
              // onChange={({ min, max }) => {
              //   setMinNps(minNps);
              //   setMaxNps(maxNps);
              //   console.log(minNps,max)
              // }}
            />
          </div>
          <div className="col-6">
            <div className=" my-2">
              <select
                className="form-select "
                value={searchFilter?.dcLogo}
                onChange={(e) =>
                  changeHandler(
                    "dcLogo",
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null
                  )
                }
              >
                <option value=""> Provider Logo </option>
                <option value="true"> Yes </option>
                <option value="false"> No </option>
              </select>
            </div>
          </div>
          <div className="col-6">
            <div className=" my-2">
              <select
                className="form-select"
                value={searchFilter?.doctorPhoto}
                onChange={(e) =>
                  changeHandler(
                    "doctorPhoto",
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null
                  )
                }
              >
                <option value=""> Doctor Photo </option>
                <option value="true"> Yes </option>
                <option value="false"> No </option>
              </select>
            </div>
          </div>
          <div className="col-6">
            <div className=" my-2">
              <select
                className="form-select"
                value={searchFilter?.centrePhoto}
                onChange={(e) =>
                  changeHandler(
                    "centrePhoto",
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null
                  )
                }
              >
                <option value=""> Center Photo </option>
                <option value="true"> Yes </option>
                <option value="false"> No </option>
              </select>
            </div>
          </div>
          <div className="col-6">
            <div className=" my-2">
              <select
                className="form-select"
                value={searchFilter?.gmb}
                onChange={(e) =>
                  changeHandler(
                    "gmb",
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null
                  )
                }
              >
                <option value=""> Google My Bussiness </option>
                <option value="true"> Yes </option>
                <option value="false"> No </option>
              </select>
            </div>
          </div>
          <div className="col-6">
            <div className=" my-2">
              <select
                className="form-select"
                value={searchFilter?.IsDoctorSlot}
                onChange={(e) =>
                  changeHandler(
                    "IsDoctorSlot",
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null
                  )
                }
              >
                <option value="">Doctor Slot</option>
                <option value="true"> Yes </option>
                <option value="false"> No </option>
              </select>
            </div>
          </div>
          <div className="col-12">
            <div className="my-2">
              <Select
                placeholder="Provider Grade"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                isMulti
                options={getAdditionalFilter?.lstProvidersClass?.map((ele) => {
                  return {
                    value: ele?.providerClass,
                    label: ele?.providerClass,
                  };
                })}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    providerClassIds: e.map((ele) => ele.value).toString(),
                  });
                  setProviderGrade(e);
                }}
                isClearable={true}
                value={providerGrade === null ? "" : providerGrade}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="my-2">
              <Select
                placeholder="Provider Certificate"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                isMulti
                options={certificateArray?.map((ele) => {
                  return {
                    value: ele,
                    label: ele,
                  };
                })}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    providerCertificateCodes: e
                      .map((ele) => ele.value)
                      .toString(),
                  });
                  setCertificate(e);
                }}
                isClearable={true}
                value={certificate === "" ? "" : certificate}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="my-2">
              <Select
                placeholder="Provider Type"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                isMulti
                options={getAdditionalFilter?.lstProviderType?.map((ele) => {
                  return {
                    value: ele?.providerCategoryId,
                    label: ele?.providerCategoryName,
                  };
                })}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    providerCategoryIds: e.map((ele) => ele.value).toString(),
                  });
                  setProviderType(e);
                }}
                isClearable={true}
                value={providerType === null ? "" : providerType}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="my-2">
              <Select
                placeholder="Doctor Qualification"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                isMulti
                options={getAdditionalFilter?.lstDoctorQualification?.map(
                  (ele) => {
                    return {
                      value: ele?.qualificationId,
                      label: ele?.qualificationName,
                    };
                  }
                )}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    qualificationIds: e.map((ele) => ele.value).toString(),
                  });
                  setQualifaction(e);
                }}
                isClearable={true}
                value={qualifaction === null ? "" : qualifaction}
              />
            </div>
          </div>
          <div className="col-12">
            <div className="my-2">
              <Select
                placeholder="Doctor Experience"
                className="basic-multi-select"
                classNamePrefix="select"
                name="colors"
                isMulti
                options={getAdditionalFilter?.lstDoctorExperience?.map(
                  (ele) => {
                    return {
                      value: ele?.id,
                      label: ele?.name,
                    };
                  }
                )}
                onChange={(e) => {
                  setSearchFilter({
                    ...searchFilter,
                    experienceIds: e.map((ele) => ele.label).toString(),
                  });
                  setExperience(e);
                }}
                isClearable={true}
                value={experience === null ? "" : experience}
              />
            </div>
          </div>
          
        </div>
        <button
          className="search"
          type="button"
          style={{ border: "none", float: "right", marginTop: "15px" }}
          onClick={() => applyFilter()}
        >
          <a className="sidebar-links">Apply Filter</a>
        </button>
      </div>
    </>
  );
};
